"use strict";

exports.__esModule = true;
exports.formatCreator = exports.formatAuthor = exports.formatAssignee = void 0;
var _User = require("../../../User");
/* eslint-disable */

/**
 * For the data value apply the formatting preferences to the value
 */
var formatCreator = exports.formatCreator = function formatCreator(creatorId, columnSettings, users, translate) {
  var user = creatorId ? users.getUser(creatorId) : null;
  return user ? (0, _User.getUserFullName)(user) : translate("DataTable.Creator.Internal", "Internal User");
};
var formatAssignee = exports.formatAssignee = function formatAssignee(assigneeId, columnSettings, users, translate) {
  var assignee = assigneeId ? users.getUser(assigneeId) : null;
  return assignee ? (0, _User.getUserFullName)(assignee) : translate("DataTable.Assignee.Unassigned", "Unassigned");
};
var formatAuthor = exports.formatAuthor = function formatAuthor(username, columnSettings, users, translate) {
  var user = username ? users.getUserByName(username) : null;
  return user ? (0, _User.getUserFullName)(user) : translate("DataTable.Creator.Internal", "Internal User");
};